import { render, staticRenderFns } from "./inheritEmployeesList.vue?vue&type=template&id=19b47cd2&scoped=true&"
import script from "./inheritEmployeesList.vue?vue&type=script&lang=js&"
export * from "./inheritEmployeesList.vue?vue&type=script&lang=js&"
import style0 from "./inheritEmployeesList.vue?vue&type=style&index=0&id=19b47cd2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b47cd2",
  null
  
)

export default component.exports